export default __webpack_public_path__ + "static/media/switchGame.3db4bdae.webp";